module.exports = __webpack_public_path__ + "img/moi à la maternelle.8a7ba1cb.jpg";